module.exports = __webpack_public_path__ + "img/book-13.fd400c00.png";